"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("../../Card"));

var _Detail = _interopRequireDefault(require("../../Card/Detail"));

var _Header = _interopRequireDefault(require("../../Card/Header"));

var _Image = _interopRequireDefault(require("../../Card/Image"));

var _Pill = _interopRequireDefault(require("../../Card/Pill"));

var _Section = _interopRequireDefault(require("../../Card/Section"));

var _SlideScroll = _interopRequireDefault(require("../SlideScroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    body: {
      background: theme.palette.background.default
    }
  };
});
/**
* Moment for visualizing people relavent to the `Story`'s main subject.
*/

function PeopleMoment(props) {
  var data = props.data;
  var classes = useStyles();
  return _react.default.createElement(_SlideScroll.default, _extends({
    bodyClassName: classes.body
  }, props), data.map(function (_ref) {
    var description = _ref.description,
        image = _ref.image,
        label = _ref.label,
        relations = _ref.relations,
        years = _ref.years;
    return _react.default.createElement(_Card.default, {
      style: {
        maxWidth: "300px"
      }
    }, image && _react.default.createElement(_Image.default, {
      src: image,
      draggable: false
    }), _react.default.createElement(_Header.default, {
      text: label
    }), years && _react.default.createElement(_Pill.default, {
      text: years
    }), relations && relations.map(function (relation) {
      return _react.default.createElement(_Section.default, null, relation);
    }), description && _react.default.createElement(_Detail.default, null, description));
  }));
}

PeopleMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Determines the information to use in each `Card`. */
  data: _propTypes.default.arrayOf(_propTypes.default.object),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
};
PeopleMoment.defaultProps = {
  type: "people"
};
var _default = PeopleMoment;
exports.default = _default;